
<template>
  <div  class="login-container">

    <!-- ユーザー認証中の表示 -->
    <div v-if="true === IsCheckingLoign">
      <p class="checking-login  ">
      <i class="fas fa-spinner  fa-pulse"></i><span class="faa-flash animated">ユーザーをかくにんしています...</span>
      </p>
    </div>

    <router-view v-if="false === IsCheckingLoign" :trial="trial" />
  </div>
</template>


<script>
export default {
  name: "LoginPage",
  data() {
    return {
      IsCheckingLoign:true//ユーザー確認中
    };
  },
    props:{
    trial:Boolean
    },
  mounted() {
    this.IsCheckingLoign = true;
   
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$router.push("/thinkpage");
        
        return;
      }
      this.IsCheckingLoign = false
    });
  },
};
</script>

<style scoped lang="scss">

//---------------
// ユーザー確認中表示
//---------------
.checking-login{
  text-align: center;
  height:100px;
  color:#42b983;
  font-weight: 600;
  font-size:24px;
  margin-top:100px;
  & > i{
    margin-right:8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LoginPage.vue